import { render, staticRenderFns } from "./dubaiBanks-report.vue?vue&type=template&id=9e487278&"
import script from "./dubaiBanks-report.vue?vue&type=script&lang=js&"
export * from "./dubaiBanks-report.vue?vue&type=script&lang=js&"
import style0 from "./dubaiBanks-report.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VDatePicker,VMenu,VTextField})
